import { NgModule } from '@angular/core';
import { SanitizeHtmlPipe } from '../pipes/sanitize.pipe';
import { FormatNumberPipe } from '../pipes/format-number.pipe';

@NgModule({
  declarations: [SanitizeHtmlPipe, FormatNumberPipe],
  exports: [SanitizeHtmlPipe, FormatNumberPipe],
})
export class PipesModule {}
